import React from 'react'
import type { CssBaselineProps as MuiCssBaselineProps } from '@material-ui/core/CssBaseline'
import MuiCssBaseline from '@material-ui/core/CssBaseline'

export type CssBaselineProps = MuiCssBaselineProps

function CssBaseline(props: CssBaselineProps) {
  return <MuiCssBaseline {...props} />
}

export default CssBaseline
